"use client"

import { useCallback, useEffect, useState } from "react"
import { getKonfigurasiCaptcha } from "@/modules/captcha/actions/captcha-actions"
import type { KonfigurasiCaptchaPublik } from "@/modules/pengaturan/domain/types"

export function useCaptcha() {
  const [konfigurasi, setKonfigurasi] = useState<KonfigurasiCaptchaPublik | null>(null)
  const [token, setToken] = useState<string | null>(null)
  const [versi, setVersi] = useState(0)

  useEffect(() => {
    getKonfigurasiCaptcha()
      .then(setKonfigurasi)
      .catch(() => setKonfigurasi({ aktif: false, siteKey: "" }))
  }, [])

  const reset = useCallback(() => {
    setToken(null)
    setVersi((v) => v + 1)
  }, [])

  return {
    aktif: konfigurasi?.aktif === true,
    siteKey: konfigurasi?.siteKey ?? "",
    siap: konfigurasi !== null,
    token,
    versi,
    setToken,
    reset,
    perluDiselesaikan: konfigurasi?.aktif === true && token === null,
  }
}

export type StateCaptcha = ReturnType<typeof useCaptcha>
